import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=754b2ef1"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('754b2ef1')) {
      api.createRecord('754b2ef1', component.options)
    } else {
      api.reload('754b2ef1', component.options)
    }
    module.hot.accept("./agreement.vue?vue&type=template&id=754b2ef1", function () {
      api.rerender('754b2ef1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/agreement/agreement.vue"
export default component.exports